import { api } from './client.js';

const root = '/ai';

export const chatApi = {
  agents: () => api.get(`${root}/agents`),
  chat: (body) => api.post(`${root}/chat`, body),
  listConversations: (params) => api.get(`${root}/conversations`, { query: params }),
  getConversation: (id) => api.get(`${root}/conversations/${id}`),
  deleteConversation: (id) => api.delete(`${root}/conversations/${id}`),
  feedback: (body) => api.post(`${root}/feedback`, body)
};
